import React from 'react';
import { FaFacebook, FaInstagram, FaTiktok, FaWhatsapp } from 'react-icons/fa';
import { content, contactInfo } from '../data/mock';
import './Social.css';

const iconMap = {
  facebook: FaFacebook,
  instagram: FaInstagram,
  music: FaTiktok,
  'message-circle': FaWhatsapp
};

const Social = ({ language }) => {
  const t = content[language].social;

  const getLink = (platformName) => {
    switch (platformName) {
      case 'WhatsApp':
        return contactInfo.whatsappUrl;
      case 'Facebook':
        return contactInfo.socialLinks.facebook;
      case 'Instagram':
        return contactInfo.socialLinks.instagram;
      case 'TikTok':
        return contactInfo.socialLinks.tiktok;
      default:
        return '#';
    }
  };

  return (
    <section>
      <div className="container">
        <div className="section-head">
          <h2>{t.title}</h2>
          <p>{t.subtitle}</p>
        </div>
        <div className="social-grid">
          {t.platforms.map((platform, index) => {
            const Icon = iconMap[platform.icon];
            return (
              <div key={index} className="social-card">
                <span className={`social-icon social-${platform.icon}`}>
                  <Icon size={32} />
                </span>
                <strong>{platform.name}</strong>
                <br />
                <a
                  href={getLink(platform.name)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {platform.label}
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Social;
